export default __webpack_public_path__ + "static/media/easy.6897d0ef.png";